function optionChange(e) {}

function quickView(productHandle) {
    // Create quick-view container if it doesn't exist
    let quickViewEl = document.getElementById('quick-view');
    if (!quickViewEl) {
        quickViewEl = document.createElement('div');
        quickViewEl.id = 'quick-view';
        document.body.appendChild(quickViewEl);
        document.body.classList.add('quick-view_popup');
    }

    quickViewEl.classList.add(productHandle);
    quickViewEl.innerHTML = '<div class="quick-view-overlay"></div><div class="quick-view-content"><button class="quick-view-close" aria-label="Close">&times;</button><div class="loader">Loading...</div><div class="quick_image"></div><div class="new_product"></div></div>';

    // Show modal
    quickViewEl.style.display = 'block';
    document.body.classList.add('quick-view_popup');

    // Bind close events
    const closeBtn = quickViewEl.querySelector('.quick-view-close');
    const overlay = quickViewEl.querySelector('.quick-view-overlay');

    function closeQuickView() {
        quickViewEl.style.display = 'none';
        quickViewEl.className = '';
        quickViewEl.innerHTML = '';
        document.body.classList.remove('quick-view_popup');
    }

    if (closeBtn) closeBtn.addEventListener('click', closeQuickView);
    if (overlay) overlay.addEventListener('click', closeQuickView);

    // Fetch product JSON
    fetch('/products/' + productHandle + '.js')
        .then(response => response.json())
        .then(productData => {
            // Fetch full product HTML
            fetch('/products/' + productHandle)
                .then(response => response.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const productContent = doc.querySelector('.qu_product');

                    const images = productData.images;
                    const imageContainer = quickViewEl.querySelector('.quick_image');

                    // Add images
                    images.forEach((imgUrl, index) => {
                        const imgHtml = '<img src="' + imgUrl.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png') + '" alt="Product image">';
                        imageContainer.insertAdjacentHTML('beforeend', imgHtml);
                    });

                    // Add product content
                    const newProductContainer = quickViewEl.querySelector('.new_product');
                    if (productContent && newProductContainer) {
                        newProductContainer.appendChild(productContent);
                    }

                    // Remove unwanted elements
                    const paymentBtn = quickViewEl.querySelector('.shopify-payment-button');
                    if (paymentBtn) paymentBtn.remove();

                    setTimeout(function() {
                        const breadcrumb = quickViewEl.querySelector('.breadcrumb');
                        if (breadcrumb) breadcrumb.remove();

                        const modalOpener = quickViewEl.querySelector('modal-opener');
                        if (modalOpener) modalOpener.remove();

                        const loader = quickViewEl.querySelector('.loader');
                        if (loader) loader.style.display = 'none';

                        // Simple image navigation (arrows)
                        const imgs = imageContainer.querySelectorAll('img');
                        if (imgs.length > 1) {
                            let currentIndex = 0;

                            // Hide all but first image
                            imgs.forEach((img, i) => {
                                if (i !== 0) img.style.display = 'none';
                            });

                            // Add navigation arrows
                            const prevArrow = document.createElement('button');
                            prevArrow.className = 'quick-view-prev';
                            prevArrow.innerHTML = '&#8249;';
                            prevArrow.setAttribute('aria-label', 'Previous image');

                            const nextArrow = document.createElement('button');
                            nextArrow.className = 'quick-view-next';
                            nextArrow.innerHTML = '&#8250;';
                            nextArrow.setAttribute('aria-label', 'Next image');

                            imageContainer.appendChild(prevArrow);
                            imageContainer.appendChild(nextArrow);

                            prevArrow.addEventListener('click', function() {
                                imgs[currentIndex].style.display = 'none';
                                currentIndex = (currentIndex - 1 + imgs.length) % imgs.length;
                                imgs[currentIndex].style.display = '';
                            });

                            nextArrow.addEventListener('click', function() {
                                imgs[currentIndex].style.display = 'none';
                                currentIndex = (currentIndex + 1) % imgs.length;
                                imgs[currentIndex].style.display = '';
                            });
                        }
                    }, 100);
                });
        });
}

// Add basic styles for quick view modal
(function() {
    if (document.getElementById('quick-view-styles')) return;

    const style = document.createElement('style');
    style.id = 'quick-view-styles';
    style.textContent = `
        #quick-view {
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 9999;
        }
        #quick-view .quick-view-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.5);
        }
        #quick-view .quick-view-content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #fff;
            max-width: 1040px;
            max-height: 90vh;
            width: 90%;
            overflow-y: auto;
            padding: 20px;
            display: flex;
            flex-wrap: wrap;
        }
        #quick-view .quick-view-close {
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 30px;
            background: none;
            border: none;
            cursor: pointer;
            z-index: 10;
        }
        #quick-view .quick_image {
            width: 50%;
            position: relative;
        }
        #quick-view .quick_image img {
            max-width: 100%;
            height: auto;
        }
        #quick-view .new_product {
            width: 50%;
            padding-left: 20px;
        }
        #quick-view .loader {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        #quick-view .quick-view-prev,
        #quick-view .quick-view-next {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            background: rgba(255,255,255,0.8);
            border: none;
            font-size: 30px;
            padding: 10px 15px;
            cursor: pointer;
            z-index: 5;
        }
        #quick-view .quick-view-prev { left: 10px; }
        #quick-view .quick-view-next { right: 10px; }
        @media (max-width: 768px) {
            #quick-view .quick_image,
            #quick-view .new_product {
                width: 100%;
                padding-left: 0;
            }
        }
    `;
    document.head.appendChild(style);
})();
